import { IEquipment, IEquipmentDocument } from '@/pages/Equipment/equipment.types'
import DropArea from '@/shared/Files/Droparea'
import ThreeDotsLoader from '@/shared/Loaders/ThreeDotsLoader'
import PlusIcon from '@/assets/icons/plus.svg?react'
import LibraryDocumentTile from '@/pages/Library/components/LibraryDocumentTile'
import useDroparea from '@/shared/Files/hooks/useDroparea'
import useHttpLoader from '@/shared/hooks/useHttpLoader'
import css from './styles.module.css'
import domUtils from '@/utils/dom.utils'
import useEquipmentFiles from '@/pages/Equipment/hooks/useEquipmentFiles'
import mediaPreviewService from '@/services/MediaPreviewService/mediaPreview.service'
import confirmService from '@/services/ConfirmService/confirm.service'

interface IProps {
  equipmentId: IEquipment['id']
}
const LiftFilesTabContent = (props: IProps) => {
  const { wait, loading } = useHttpLoader()

  const ctrl = useEquipmentFiles(props.equipmentId)

  const dropAreaCtrl = useDroparea({
    onFiles: (files) => {
      const job = async () => {
        const resp = await Promise.all(files.map((f) => ctrl.handlers.handleDocumentCreate(f)))

        return resp
      }

      wait(job())
    },
  })

  const handleUploadFile = () => {
    domUtils
      .requestUploadFile()
      .then((file) => {
        wait(ctrl.handlers.handleDocumentCreate(file))
      })
      .catch()
  }

  const openMediaPreview = (index: number) => {
    mediaPreviewService.requestMediaPreview(
      ctrl.data.documents.map((f) => ({
        ...f,
        url: ctrl.handlers.getDocumentUrl(f),
      })),
      index
    )
  }

  const handleDelete = (document: IEquipmentDocument) => {
    confirmService.requestConfirm({
      buttonType: 'primary',
      description: `Вы действительно хотите удалить файл ${document.fileName}?`,
      onConfirm: () => ctrl.handlers.handleDocumentRemove(document.id),
    })
  }

  return (
    <div className={css.wrapper}>
      <DropArea
        onDrop={dropAreaCtrl.handleDrop}
        isActive={dropAreaCtrl.over}
        onDragOver={dropAreaCtrl.handleDragOver}
        onDragEnter={dropAreaCtrl.handleDragEnter}
        onDragLeave={dropAreaCtrl.handleDragLeave}
        style={{ flex: 1, minHeight: 0, overflow: 'auto', height: '100%' }}
      >
        {ctrl.data.dataLoading && (
          <div className="flex-lines center" style={{ flex: 1, height: '80%' }}>
            <ThreeDotsLoader inscription="Загружаем список файлов..." />
          </div>
        )}
        <div className="inline-flex-gap gap24" style={{ flexWrap: 'wrap' }}>
          {!ctrl.data.dataLoading && (
            <div className={css.createTileWrapper} onClick={handleUploadFile}>
              {loading ? (
                <ThreeDotsLoader inscription={`Загрузка файлов\nНе уходите со страницы`} />
              ) : (
                <>
                  <div className={css.plusIconWrapper}>
                    <PlusIcon className={css.plusIcon} />
                  </div>
                  <p className="text-nm text-secondary text-center" style={{ width: '80%' }}>
                    Нажмите либо перетащите файлы для загрузки
                  </p>
                </>
              )}
            </div>
          )}

          {ctrl.data.documents.map((d, index) => (
            <LibraryDocumentTile
              key={d.id}
              onClick={() => openMediaPreview(index)}
              onDelete={() => handleDelete(d)}
              documentUrl={ctrl.handlers.getDocumentUrl(d)}
              document={d}
              index={index}
            />
          ))}
        </div>
      </DropArea>
    </div>
  )
}

export default LiftFilesTabContent
